import { handleResponse, makeGet } from './helpers';

type GetHouseTermsParams = {
    authToken: string;
    deployment: string;
};

export default {
    getHouseTerms: ({ authToken, deployment }: GetHouseTermsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'houses/terms',
                authToken,
                deployment,
                path: '<BILLING-API>',
            });
            request.end((err, response) => handleResponse({ err, reject, resolve, response }));
        }),
};
